import React from 'react'

//components
import LatestFromThrive from '../../elements/LatestFromThrive/LatestFromThrive';
import YourWorkspaces from '../../elements/workspaces/YourWorkspaces'
import InsightHighlights from '../../elements/InsightHighlights/InsightHighlights'
import IntroModal from '../../modals/IntroModal'

//styles
import '../../../css/home/home.scss';


const Home = () => {  
    return(
        <div className="react-gen-container thrive-gen-container tracks-home-container clearfix">
            <section className="thrive-panel thrive-big-panel">
                <LatestFromThrive />
            </section>
        
            <aside style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
                <YourWorkspaces />
        
                <InsightHighlights />
    
                <IntroModal />
            </aside>  
        </div>
    )
}

export default Home